import { useEffect, useRef, useState } from "react";

export function Reveal({ children, delay = 0, className = "", as: Tag = "div" }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setShown(true);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <Tag
      ref={ref}
      className={`reveal ${shown ? "in" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </Tag>
  );
}

export function Eyebrow({ children, light = false }) {
  return (
    <span
      className="eyebrow"
      style={light ? { color: "var(--gold-2)" } : undefined}
    >
      {children}
    </span>
  );
}

export function SectionHeader({ eyebrow, title, sub, center = true, light = false }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl`}>
      <Reveal>
        <Eyebrow light={light}>{eyebrow}</Eyebrow>
      </Reveal>
      <Reveal delay={80}>
        <h2
          className="display-title mt-4 text-4xl md:text-5xl"
          style={{ color: light ? "#fff" : "var(--ink)" }}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </Reveal>
      {sub && (
        <Reveal delay={160}>
          <p
            className="mt-5 text-lg leading-relaxed"
            style={{ color: light ? "rgba(255,255,255,0.7)" : "var(--muted)" }}
          >
            {sub}
          </p>
        </Reveal>
      )}
    </div>
  );
}
